import React, { useState } from 'react';
import styles from './Stepper.scss';
import { IStepProps } from './Step';

export interface IStepperProps {
    // id: string;
    className?: string;
    successHandler?: () => void;
    onChange?: (step: number) => void;
}

const Stepper: React.FC<React.PropsWithChildren<IStepperProps>> = ({ className = '', successHandler = () => {}, children, onChange }) => {
    const [step, setStep] = useState(0);

    let lastIndex = 0;
    React.Children.forEach(children, (child: React.ReactElement<IStepProps, React.FC<React.PropsWithChildren<unknown>>>, idx) => {
        if (child && child.type.displayName === 'Step') {
            lastIndex++;
        }
    });

    const handleNext = (_number: number) => {
        if (step + 1 >= lastIndex) {
            successHandler();
        }
        setStep(step + 1);
        onChange && onChange(step + 1);
    };

    const handleGoBack = (number: number) => {
        setStep(number - 1);
        onChange && onChange(number - 1);
    };

    const toRender = [];

    let stepIndex = 0;
    React.Children.forEach(children, (child: React.ReactElement<IStepProps, React.FC<React.PropsWithChildren<unknown>>>, idx) => {
        if (child && child.type.displayName === 'Step') {
            toRender.push(
                React.cloneElement(child, {
                    ...child.props,
                    _isActive: step === stepIndex,
                    _isDone: step > stepIndex,
                    _isLast: stepIndex + 1 === lastIndex,
                    _number: stepIndex + 1,
                    _nextHandler: handleNext,
                    _goBackHandler: handleGoBack,
                    key: idx,
                })
            );
        } else {
            toRender.push(child);
        }
        stepIndex++;
    });

    const cn = [styles.stepper, className].join(' ');
    return <div className={cn}>{toRender}</div>;
};

export default Stepper;
